import React from 'react';
import usePageView from '@sls-react/hooks/usePageView';
import PageView from '@sls-react/components/legos/PageView';
import { useRouter } from '@sls-react/routing';
import useKnownCookie from '@sls-react/hooks/useKnownCookie';
import { isEqual } from 'date-fns';
import { createGlobalState } from 'react-use';
import { microBannerPageViewId } from '../../../constants/hardcodedPageViewIds';

// When clicking the X button on the micro banner, this will cause the micro banner to update
// and hide. Super big hack.
export const useMicroBannerDismissalState = createGlobalState<number>(0);

interface Props {}

const MicroBanner: React.FC<Props> = () => {
  const { data: pageView } = usePageView(microBannerPageViewId);
  const [time] = useKnownCookie('sls_dmicro_b');
  const router = useRouter();
  const [state] = useMicroBannerDismissalState();

  if (
    !pageView ||
    ![
      '/',
      '/shop/[...lander]',
      '/gear/[...item]',
      '/sell-now',
      '/[username]',
      '/[username]/[itemState]',
      '/[username]/about',
      '/[username]/favorites',
      '/[username]/feedback',
      '/[username]/followers',
      '/[username]/following',
    ].includes(router.route)
  ) {
    return null;
  }

  if (time && isEqual(new Date(+time), new Date(pageView.updated_at))) {
    return null;
  }

  if (state! > 0) {
    return null;
  }

  return <PageView pageView={pageView} allowBlockLayouts={['micro-banner']} />;
};

export default MicroBanner;
